import React from "react";
import { RxBarChart } from "react-icons/rx";
import { useTranslation } from "react-i18next";

const ChartsEmptyState = () => {
	const { t } = useTranslation();

	const requirements = [
		t("plan.charts.emptyRequirementStaffing"),
		t("plan.charts.emptyRequirementTargetHours"),
		t("plan.charts.emptyRequirementEmployees"),
	];

	return (
		<div className="plan-charts-empty">
			<div className="plan-charts-empty__card">
				<span className="plan-charts-empty__icon" aria-hidden="true">
					<RxBarChart size={28} />
				</span>
				<h3 className="plan-charts-empty__title">
					{t("plan.charts.emptyTitle")}
				</h3>
				<p className="plan-charts-empty__intro">
					{t("plan.charts.emptyIntro")}
				</p>
				<p className="plan-charts-empty__requirements-label">
					{t("plan.charts.emptyRequirementsLabel")}
				</p>
				<ul className="plan-charts-empty__requirements">
					{requirements.map((requirement) => (
						<li key={requirement}>{requirement}</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default ChartsEmptyState;
